import { clientsImg, surveyStepImg5 } from "assets/images";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsPlayCircle } from "react-icons/bs";
import "./HomePage.scss";
import { shareIcon } from "assets/icons";

import {
  appDetails,
  cardsData,
  experienceData,
  faqs,
  surveySteps,
  testimonials,
} from "constant/staticData";
import CustomModal from "components/modals/CustomModal";
import { useTranslation } from "react-i18next";

const TestimonialCard = ({ img, feedback, name, role }) => (
  <div className="item">
    <div className="testimonials_card">
      <img src={img} alt="" />
      <div className="content">
        <p>{feedback}</p>
        <ul>
          <li>{name}</li>
          <li>{role}</li>
        </ul>
      </div>
    </div>
  </div>
);

const SurveyStepCard = ({ img, title, description }) => (
  <div className="survey_steps">
    <div className="image_Wrap">
      <img src={img} alt={title} />
    </div>
    <div className="content">
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </div>
);

const AppCard = ({ img, title, description, linkText }) => (
  <div className="item">
    <div className="_card">
      <img src={img} alt={title} />
      <div className="content">
        <h4>{title}</h4>
        <p>{description}</p>
        <Link to="">
          {linkText} <img src={shareIcon} alt="Share Icon" />
        </Link>
      </div>
    </div>
  </div>
);

const HomePage = () => {
  const [videoModal, setVideoModal] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <div className="home_page">
        <div className="home_banner spacing">
          <div className="container">
            <div className="banner_content">
              <h1>
                <span>{t("HOME-BODY.yourPower")} </span>
                {` ${t("HOME-BODY.decisionWithProfessionalSurvey")}`}
              </h1>
              <p>{t("HOME-BODY.decisionWithProfessionalSurveyDescription")}</p>
              <div className="button_wrap">
                <Link to="" className="button">
                  {t("HOME-BODY.downloadMobileApp")}
                </Link>
                {/* <button
                  type="button"
                  to=""
                  className="button light has_icon"
                  onClick={() => setVideoModal(true)}
                >
                  <BsPlayCircle />
                  {t("HOME-BODY.viewDemoVideo")}
                </button> */}
              </div>
            </div>
            <div className="banner_img">
              <img src={surveyStepImg5} alt="" />
            </div>
          </div>
        </div>

        {/* <div className="testimonials spacing">
          <div className="container">
            <div className="card_wrap">
              {testimonials.map((testimonial, index) => (
                <TestimonialCard
                  key={`testimonials-${index}`}
                  img={testimonial.img}
                  feedback={t(`HOME-BODY.testimonial-feedback-${index}`)}
                  name={t(`HOME-BODY.testimonial-name-${index}`)}
                  role={t(`HOME-BODY.testimonial-role-${index}`)}
                />
              ))}
            </div>
          </div>
        </div> */}

        <div className="design_survey_steps spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                {`${t("HOME-BODY.designeSurveyFlexibility")} `}
                <span>{t("HOME-BODY.fingerTips")}</span>.
              </h3>
            </div>
            {surveySteps.map((step, index) => (
              <SurveyStepCard
                key={`surveySteps-${index}`}
                img={step.img}
                title={t(`HOME-BODY.surveyStep-title-${index}`)}
                description={t(`HOME-BODY.surveyStep-description-${index}`)}
              />
            ))}
          </div>
        </div>

        <div className="seamless_survey spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                <span> {t("HOME-BODY.seamlessSurvey")} : </span>
                {` ${t("HOME-BODY.empoweringClient")}`}
              </h3>
            </div>
            <div className="card_wrap">
              {appDetails.map((app, index) => (
                <AppCard
                  key={`appDetails-${index}`}
                  img={app.img}
                  title={t(`HOME-BODY.appDetail-title-${index}`)}
                  description={t(`HOME-BODY.appDetail-description-${index}`)}
                  linkText={t(`HOME-BODY.appDetail-linkText-${index}`)}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="start_journey spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                {t("HOME-BODY.startYourJourney")}
                <span> {t("HOME-BODY.insightContinue")}</span>{" "}
                {t("HOME-BODY.onTheAppVisitOnline")}
              </h3>
            </div>
            <div className="button_wrap">
              <Link to="/signup" className="button">
                {t("HOME-BODY.signupFree")}
              </Link>
              <Link to="" className="button light">
                {t("HOME-BODY.downloadMobileApp")}
              </Link>
            </div>
          </div>
        </div>

        <div className="how_it_works seamless_survey  spacing">
          <div className="container">
            <div className="page_title">
              <h3>{t("HOME-BODY.howItWork")}</h3>
            </div>
            <div className="card_wrap">
              {cardsData.map((card, index) => (
                <div className="item" key={card?.key || index}>
                  <div className="_card">
                    <img
                      src={card?.image || ""}
                      alt={card?.title || `card ${index}`}
                    />
                    <div className="content">
                      <h4>
                        <span>{card?.key || index}</span>
                        {t(`HOME-BODY.cardData-title-${index}`) || ""}
                      </h4>
                      {card.description.map((paragraph, innerIndex) => (
                        <p key={index}>
                          {t(
                            `HOME-BODY.cardData-description-${index}-${innerIndex}`
                          )}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="Participants spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                <span>{t(`HOME-BODY.seamlessSurvey`)} : </span>
                {` ${t(`HOME-BODY.empoweringClientParticipant`)}`}
              </h3>
            </div>

            <div className="Participants_content_wrap">
              <div className="image_wrap">
                <img src={clientsImg} alt="" />
              </div>
              <div className="content">
                <p>
                  {t(`HOME-BODY.welcomeTo`)}
                  <span> {t(`HOME-BODY.caseBased`)}</span>,{" "}
                  {t(`HOME-BODY.caseBasedDescription`)}
                </p>
                <p>
                  {t(`HOME-BODY.at`)} <span> {t(`HOME-BODY.caseBased`)}</span>,{" "}
                  {t(`HOME-BODY.atCaseBasedDescription`)}
                </p>
                <div className="button_wrap">
                  <Link to={"/signup"} type="button" className="button">
                    {t(`HOME-BODY.getStarted`)}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="app_experience spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                {t(`HOME-BODY.featureElevate`)}{" "}
                <span> {t(`HOME-BODY.yourExperience`)}</span>
              </h3>
              <p>{t(`HOME-BODY.featureElevateDescription`)}</p>
            </div>
            <div className="card_wrap">
              {experienceData.map((item, index) => (
                <div key={item?.id || index} className="item">
                  <div className="experience_card">
                    <img src={item?.icon || ""} alt={item?.title || ""} />
                    <h5>
                      {t(`HOME-BODY.experienceData-title-${index}`) || ""}
                    </h5>
                    <p>
                      {t(`HOME-BODY.experienceData-description-${index}`) || ""}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ */}

        <div className="faqs spacing">
          <div className="container">
            <div className="page_title">
              <h3>
                {t(`HOME-BODY.exploreOur`)}
                <span> {t(`HOME-BODY.frequentlyAskedQuestion`)}</span>
              </h3>
              <p>{t(`HOME-BODY.frequentlyAskedQuestionDescription`)}</p>
            </div>

            <div className="card_wrap">
              {faqs.map((faq, index) => (
                <div className="item" key={faq?.key || index}>
                  <div className="faq_card">
                    <img src={faq?.image || ""} alt={`FAQ ${faq.key}`} />
                    <div className="content">
                      <h5>{t(`HOME-BODY.faq-title-${index}`) || ""}</h5>
                      <p>{t(`HOME-BODY.faq-description-${index}`) || ""}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={videoModal}
        className={"xl videoModal"}
        handleClose={() => setVideoModal(false)}
      >
        <video controls autoPlay>
          <source
            src="http://media.w3.org/2010/05/sintel/trailer.mp4"
            type="video/mp4"
          />
          <source src="movie.ogg" type="video/ogg" />
          {t(`HOME-BODY.doesNotSupportVideoTag`)}
        </video>
      </CustomModal>
    </>
  );
};

export default HomePage;
